import React, { Component } from 'react';
import Col from 'react-bootstrap/lib/Col';
import Image from 'react-bootstrap/lib/Image';
import Row from 'react-bootstrap/lib/Row';
import { Link } from 'react-router-dom';
import { useQuery } from '../App';
import logo from '../static/logo/mc_logo.png';
import logo_mobile from '../static/logo/mc_logo_mobile.png';
import './Header.css';
let back = 'http://localhost:3000';

var menuStyle = {
  borderBottom: '3px solid #90cab3',
};

class MenuText extends Component {
  constructor(props) {
    super(props);
    this.state = {
      typeInState: this.props.type,
    };
    this.handleClick = this.handleClick.bind(this);
  }
  handleClick(e, data) {
    this.props.menuClick(this.props.category);
  }
  render() {
    return location.pathname.includes('/book/') ? (
      <Link to={'/?type=' + this.state.typeInState}>
        <p
          onClick={this.handleClick}
          style={this.props.active ? menuStyle : null}
          className="menuText"
        >
          {this.props.category}
        </p>
      </Link>
    ) : (
      <Link to={'/?type=' + this.state.typeInState}>
        <p
          onClick={this.handleClick}
          style={this.props.active ? menuStyle : null}
          className="menuText"
        >
          {this.props.category}
        </p>
      </Link>
    );
  }
}
const delay = (t) => new Promise((resolve) => setTimeout(resolve, t));

class OnMain extends Component {
  constructor(props) {
    super(props);
    this.state = {
      aboutHigh: false,
      contactHigh: false,
      mgmtHigh: false,
      bookingHigh: true,
      disableScroll: false,
      onMain: true,
    };
    this.calcWindow = this.calcWindow.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.menuClick = this.menuClick.bind(this);
    this.regu = this.regu.bind(this);
    this.cleanMenu = this.cleanMenu.bind(this);
  }
  calcWindow(menu) {
    var w = window;
    var d = document;
    var e = d.documentElement;
    var g = d.getElementsByTagName('body')[0];
    var x = w.innerWidth || e.clientWidth || g.clientWidth;
    var offset = 100;
    if (x < 768) {
      offset = 160;
    }
    var dest = document.querySelector('.' + menu);
    var rect = dest.getBoundingClientRect(),
      scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
      scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    var data = { top: rect.top + scrollTop, left: rect.left + scrollLeft };
    var toTop = data.top - offset;
    return toTop;
  }
  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }
  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }
  handleScroll(event) {
    if (!this.state.disableScroll && !this.state.onMain) {
      var contact = this.calcWindow('contact');
      var about = this.calcWindow('about');
      var management = this.calcWindow('management');
      var pos = window.pageYOffset || document.documentElement.scrollTop;
      var offset = 10;
      if (pos + offset < management) {
        this.setState({
          aboutHigh: false,
          contactHigh: false,
          mgmtHigh: false,
          bookingHigh: true,
        });
      } else if (management <= pos + offset && pos + offset < contact) {
        this.setState({
          aboutHigh: false,
          contactHigh: false,
          mgmtHigh: true,
          bookingHigh: false,
        });
      } else if (contact <= pos + offset && pos + offset < about) {
        this.setState({
          aboutHigh: false,
          contactHigh: true,
          mgmtHigh: false,
          bookingHigh: false,
        });
      } else if (about < pos + offset) {
        this.setState({
          aboutHigh: true,
          contactHigh: false,
          mgmtHigh: false,
          bookingHigh: false,
        });
      } else {
        this.setState({
          aboutHigh: false,
          contactHigh: false,
          mgmtHigh: false,
          bookingHigh: false,
        });
      }
    }
  }
  regu() {
    this.setState({ disableScroll: false });
  }
  cleanMenu() {
    this.setState({
      aboutHigh: false,
      contactHigh: false,
      mgmtHigh: false,
      bookingHigh: false,
    });
  }

  menuClick(target) {
    this.props.menuClickParent();
    this.setState({ disableScroll: true });
    delay(800).then(() => this.regu());
    delay(100).then(() => this.props.scroll(target));
    if (target === 'booking') {
      this.setState({
        aboutHigh: false,
        contactHigh: false,
        mgmtHigh: false,
        bookingHigh: true,
      });
    } else if (target === 'management') {
      this.setState({
        aboutHigh: false,
        contactHigh: false,
        mgmtHigh: true,
        bookingHigh: false,
      });
    } else if (target === 'contact') {
      this.setState({
        aboutHigh: false,
        contactHigh: true,
        mgmtHigh: false,
        bookingHigh: false,
      });
    } else if (target === 'about') {
      this.setState({
        aboutHigh: true,
        contactHigh: false,
        mgmtHigh: false,
        bookingHigh: false,
      });
    }
  }
  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      if (window.location.href.includes('#')) {
        this.setState({ onMain: false });
      } else {
        this.setState({ onMain: true });
        this.cleanMenu();
      }
    }
  }
  render() {
    return (
      <Col xs={12} sm={9} md={8} lg={5} className="menu">
        {this.props.type === 'booking' ? (
          <MenuText
            location={this.props.location}
            type={this.props.type}
            menuClick={this.menuClick}
            scroll={this.props.scroll}
            active={this.state.bookingHigh}
            category="booking"
          />
        ) : (
          <MenuText
            location={this.props.location}
            type={this.props.type}
            menuClick={this.menuClick}
            scroll={this.props.scroll}
            active={this.state.mgmtHigh}
            category="management"
          />
        )}
        <MenuText
          location={this.props.location}
          type={this.props.type}
          menuClick={this.menuClick}
          scroll={this.props.scroll}
          active={this.state.contactHigh}
          category="contact"
        />
        {/* <MenuText menuClick={this.menuClick} scroll={this.props.scroll} active={this.state.aboutHigh} category="about" /> */}
      </Col>
    );
  }
}

const Header = ({ menuClick, scroll }) => {
  const { type, location } = useQuery();
  return (
    <div>
      <Row className="fixed">
        <div className="content">
          <Row className="wholeHead">
            <Col xs={12} sm={3} md={4} lg={7} className="headerimg">
              <Link to={'/'} onClick={menuClick}>
                <Image
                  alt="logo"
                  src="https://s3-eu-west-1.amazonaws.com/www.birdseyeagency.com/logo.png"
                  style={{ display: 'none' }}
                />
                <Image alt="logo" className="logo" responsive src={logo} />
                <Image
                  alt="logo"
                  className="logo_mobile"
                  responsive
                  src={logo_mobile}
                />
              </Link>
            </Col>
            <OnMain
              menuClickParent={menuClick}
              scroll={scroll}
              type={type}
              location={location}
            />
          </Row>
        </div>
      </Row>
      <Row className="menuspace" />
    </div>
  );
};

export default Header;



// WEBPACK FOOTER //
// ./src/objs/Header.js